import PropTypes from 'prop-types';
import { COLOR_TEXT_PRIMARY } from '../colors/colors';

const DEFAULT_COLOR = COLOR_TEXT_PRIMARY;

export const YouLogo = ({
  color = DEFAULT_COLOR,
  width = 55,
  height = 24,
  title,
  ...rest
}) => {
  const ariaProps = title
    ? { role: 'img', 'aria-label': title }
    : { 'aria-hidden': true, focusable: false };

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 55 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...ariaProps}
      {...rest}
    >
      {title ? <title>{title}</title> : null}

      <path
        d="M41.9763 18.4532C40.438 18.4532 39.2334 17.9382 38.3623 16.908C37.5098 15.8584 37.0835 14.4007 37.0835 12.5348V2.47656H41.2535V11.5144C41.2535 12.7195 41.4295 13.6039 41.7816 14.1675C42.1338 14.7118 42.6898 14.9839 43.4496 14.9839C44.3022 14.9839 44.9602 14.6826 45.4235 14.08C45.9054 13.458 46.1463 12.5348 46.1463 11.3104V2.47656H50.668V18.4532H46.5916L46.3964 13.6136L46.9247 13.7302C46.7023 15.2851 46.174 16.461 45.34 17.2579C44.506 18.0548 43.3848 18.4532 41.9763 18.4532Z"
        fill={color}
      />
      <path
        d="M26.8709 18.8031C25.333 18.8031 23.9921 18.4727 22.8479 17.8119C21.7039 17.1316 20.813 16.1792 20.1754 14.9547C19.5377 13.7302 19.2189 12.2919 19.2189 10.6398C19.2189 8.98776 19.5377 7.55916 20.1754 6.35411C20.813 5.12963 21.7039 4.17724 22.8479 3.49698C23.9921 2.8167 25.333 2.47656 26.8709 2.47656C28.4089 2.47656 29.7498 2.8167 30.8939 3.49698C32.0379 4.17724 32.9289 5.12963 33.5665 6.35411C34.2042 7.55916 34.523 8.98776 34.523 10.6398C34.523 12.2919 34.2042 13.7302 33.5665 14.9547C32.9289 16.1792 32.0379 17.1316 30.8939 17.8119C29.7498 18.4727 28.4089 18.8031 26.8709 18.8031ZM26.8709 15.4503C27.9213 15.4503 28.737 15.0324 29.3185 14.1967C29.8998 13.3415 30.1906 12.1559 30.1906 10.6398C30.1906 9.12376 29.8998 7.9479 29.3185 7.11214C28.737 6.25694 27.9213 5.82934 26.8709 5.82934C25.8206 5.82934 25.0047 6.25694 24.4234 7.11214C23.8419 7.9479 23.5513 9.12376 23.5513 10.6398C23.5513 12.1559 23.8419 13.3415 24.4234 14.1967C25.0047 15.0324 25.8206 15.4503 26.8709 15.4503Z"
        fill={color}
      />
      <path
        d="M6.56985 22.4766V19.2112H8.54358C9.02545 19.2112 9.37758 19.1335 9.59998 18.978C9.84092 18.842 10.0262 18.5892 10.156 18.22L10.4619 17.3162H9.32198L4.09558 2.47656H8.34905L11.7684 13.2346L14.9654 2.47656H19.2189L13.492 19.5903C13.1584 20.6204 12.6765 21.359 12.0464 21.806C11.4163 22.2531 10.536 22.4766 9.40545 22.4766H6.56985Z"
        fill={color}
      />
    </svg>
  );
};

YouLogo.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
};
